import { IKeyProfiles } from "../constants/pragerohlinge";
import {
  IKey,
  IKeySideFont,
  IKeySideLogoSize,
  IKeyTextType,
  IKeyType,
} from "../store/keysTypes";
import { v4 } from "uuid";
import { IKeysBlankNames } from "../constants/pragerohlinge";

type IKeyTextFields = {
  [name: string]: IKeyTextType[];
};

const KEY_INPUTS: IKeyTextFields = {
  [IKeysBlankNames.FA]: [
    { name: "A", value: "", maxLength: 24 },
    { name: "B", value: "", maxLength: 24 },
    { name: "C", value: "", maxLength: 24 },
    { name: "D", value: "", maxLength: 24 },
  ],
  [IKeysBlankNames.OV]: [
    { name: "A", value: "", maxLength: 24 },
    { name: "B", value: "", maxLength: 24 },
    { name: "C", value: "", maxLength: 24 },
  ],
  "abu-17d": [
    { name: "A", value: "", maxLength: 24 },
    { name: "B", value: "", maxLength: 24 },
    { name: "C", value: "", maxLength: 24 },
    { name: "D", value: "", maxLength: 24 },
  ],
  "abu-86d": [
    { name: "A", value: "", maxLength: 24 },
    { name: "B", value: "", maxLength: 24 },
    { name: "C", value: "", maxLength: 24 },
    { name: "D", value: "", maxLength: 24 },
  ],
  "bk-7d": [
    { name: "A", value: "", maxLength: 24 },
    { name: "B", value: "", maxLength: 24 },
    { name: "C", value: "", maxLength: 24 },
    { name: "D", value: "", maxLength: 24 },
  ],
  "ce-53d": [
    { name: "A", value: "", maxLength: 24 },
    { name: "B", value: "", maxLength: 24 },
  ],
  "wil-66d": [
    { name: "A", value: "", maxLength: 24 },
    { name: "B", value: "", maxLength: 24 },
    { name: "C", value: "", maxLength: 24 },
  ],
  "win-22": [
    { name: "A", value: "", maxLength: 24 },
    { name: "B", value: "", maxLength: 24 },
    { name: "C", value: "", maxLength: 24 },
    { name: "D", value: "", maxLength: 24 },
  ],
  // ABU-41 variants - FA keys
  "abu-41fa": [
    { name: "A", value: "", maxLength: 24 },
    { name: "B", value: "", maxLength: 24 },
    { name: "C", value: "", maxLength: 24 },
    { name: "D", value: "", maxLength: 24 },
  ],
  "abu-41dfa": [
    { name: "A", value: "", maxLength: 24 },
    { name: "B", value: "", maxLength: 24 },
    { name: "C", value: "", maxLength: 24 },
    { name: "D", value: "", maxLength: 24 },
  ],
  // ABU-41 variants - OV keys
  "abu-41ov": [
    { name: "A", value: "", maxLength: 24 },
    { name: "B", value: "", maxLength: 24 },
    { name: "C", value: "", maxLength: 24 },
  ],
  "abu-41dov": [
    { name: "A", value: "", maxLength: 24 },
    { name: "B", value: "", maxLength: 24 },
    { name: "C", value: "", maxLength: 24 },
  ],
};

const defaultText = [
  { name: "A", value: "", maxLength: 24 },
  { name: "B", value: "", maxLength: 24 },
  { name: "C", value: "", maxLength: 24 },
  { name: "D", value: "", maxLength: 24 },
];

export const generateKeyByBlank = (
  keyType: IKeyProfiles,
  blank: IKeysBlankNames,
  defaultKey: IKey
): IKey => {
  return {
    ...defaultKey,
    menge: "250",
    id: v4(),
    ...keyType,
    blank,
  };
};

export const generateKey = (
  keyType: IKeyProfiles,
  blank: IKeysBlankNames
): IKey => {
  const text = [IKeysBlankNames.FA, IKeysBlankNames.OV].includes(blank)
    ? KEY_INPUTS[blank]
    : KEY_INPUTS[keyType.value] ?? defaultText;

  const menge = [IKeysBlankNames.FA, IKeysBlankNames.OV].includes(blank)
    ? "250"
    : "1000";

  return {
    ...keyType,
    id: v4(),
    front: {
      image: "",
      type: IKeyType.TEXT,
      font: IKeySideFont.ARIAL,
      logo: "",
      text,
      size: text.reduce(
        (acc, curr) => ({ ...acc, [curr.name]: 18 }),
        {} as { [key: string]: number }
      ),
      logoSize: IKeySideLogoSize.BIG,
      ready: false,
    },
    back: {
      type: IKeyType.TEXT,
      font: IKeySideFont.ARIAL,
      logo: "",
      image: "",
      text,
      size: text.reduce(
        (acc, curr) => ({ ...acc, [curr.name]: 18 }),
        {} as { [key: string]: number }
      ),
      logoSize: IKeySideLogoSize.BIG,
      ready: false,
    },
    blank,
    menge,
    visited: false,
  };
};
